"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Uploads = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M19.993 8.096a.999.999 0 01-.083.384 1 1 0 01-.49.52l-7 2.92a1 1 0 01-.8 0L4.62 9a1 1 0 01-.59-1.32 1 1 0 01.53-.52l7-3a1 1 0 01.82 0l7 3a1 1 0 01.613.936zm-.603 3.064l-1.28-.55-5.32 2.23a2 2 0 01-1.58 0l-5.32-2.23-1.28.55a1 1 0 00-.53.52A1 1 0 004.62 13l7 2.92a1.001 1.001 0 00.8 0l7-2.92a1 1 0 00.53-.52 1 1 0 00-.56-1.32zm0 4l-1.28-.55-5.32 2.23a2 2 0 01-1.58 0l-5.32-2.23-1.28.55a1 1 0 00-.53.52A1 1 0 004.62 17l7 2.92a1.001 1.001 0 00.8 0l7-2.92a1 1 0 00.53-.52 1 1 0 00-.56-1.32z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Uploads;
